import { connect } from 'react-redux'

import { actions as modalsActions } from '~publish/legacy/modals/reducer'
import type { RootState } from '~publish/legacy/store'

import { ProfilesDisconnectedModal } from './components/ProfilesDisconnectedModal'
import { actions } from './reducer'
import type { Profile } from './types'

export default connect(
  (state: RootState) => {
    const disconnectedProfiles =
      state.profilesDisconnectedModal.disconnectedProfiles
    let currentOrganization = state.organizations.selected
    if (!currentOrganization && state.organizations.list.length > 0) {
      currentOrganization =
        state.organizations.list.find(
          (organization) => organization.selected,
        ) || state.organizations.list[0]
    }
    const currentOrganizationId = currentOrganization?.id

    const profiles = disconnectedProfiles.filter((profile) =>
      currentOrganizationId
        ? profile.organizationId === currentOrganizationId
        : true,
    )
    const instagramPersonalProfiles = profiles.filter(
      (profile) =>
        profile.service === 'instagram' && profile.service_type === 'profile',
    )

    return {
      ...state.profilesDisconnectedModal,
      displayExtraMessage: instagramPersonalProfiles?.length > 0,
      disconnectedProfiles: profiles,
    }
  },
  (dispatch) => ({
    hideModal: (): { type: 'MODALS__HIDE_PROFILES_DISCONNECTED_MODAL' } =>
      dispatch(modalsActions.hideProfilesDisconnectedModal()),
    reconnectProfile: ({
      id,
      service,
    }: Pick<Profile, 'id' | 'service'>): void => {
      dispatch(actions.reconnectProfile({ id, service }))
    },
  }),
)(ProfilesDisconnectedModal)

export { default as reducer, actions, actionTypes } from './reducer'
export { default as middleware } from './middleware'
